import axios from "axios";
import { parseCookies } from "nookies";
import { COOKIES } from "@/constants/cookies";
import { attachUnauthorizedHandler } from "@/services/interceptors/attach-unauthorized-handler";

const extractTokenFromCookie = (): string | null => {
  try {
    const cookies = document.cookie.split(";");
    const uTokenCookie = cookies.find((cookie) =>
      cookie.trim().startsWith("u_token="),
    );

    if (!uTokenCookie) {
      const backofficeTokenCookie = cookies.find((cookie) =>
        cookie.trim().startsWith("backoffice_token="),
      );

      if (!backofficeTokenCookie) {
        return null;
      }

      return backofficeTokenCookie.split("=")[1];
    }

    return uTokenCookie.split("=")[1];
  } catch (error) {
    console.error("Erro ao extrair token do cookie:", error);
    return null;
  }
};

export const apiGateway = axios.create({
  baseURL: import.meta.env.VITE_API_GATEWAY,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Authorization for gateway routes that proxy backoffice-only services, such as
 * `/api/backoffice/spaces`: always the backoffice session cookie, the same one
 * `apiBackofficeReportsMs` sends, never the `u_token` the interceptor prefers.
 * Without the cookie the bearer goes empty and the gateway answers 401, as the
 * reports service does today.
 */
export const backofficeAuthHeaders = (): { Authorization: string } => ({
  Authorization: `Bearer ${parseCookies()[COOKIES.BACKOFFICE_AUTH] ?? ""}`,
});

apiGateway.interceptors.request.use(
  (config) => {
    // A caller that already set Authorization (see backofficeAuthHeaders) chose the token.
    if (config.headers.Authorization) {
      return config;
    }

    const token = extractTokenFromCookie();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

attachUnauthorizedHandler(apiGateway);
